import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Select1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M9 4.5H6V1.5H4.5V4.5H1.5V6H4.5V9H6V6H9V4.5zM15 4.5H12V6H15V4.5zM18 4.5V6H21V9H22.5V6C22.5 5.60218 22.342 5.22064 22.0607 4.93934 21.7794 4.65804 21.3978 4.5 21 4.5H18zM6 12H4.5V15H6V12zM6 21V18H4.5V21C4.5 21.3978 4.65804 21.7794 4.93934 22.0607 5.22064 22.342 5.60218 22.5 6 22.5H9V21H6zM22.5 12H21V15H22.5V12zM15 21H12V22.5H15V21zM21 18V21H18V22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607 22.342 21.7794 22.5 21.3978 22.5 21V18H21z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Select1.vue"]]);
